module.exports = __webpack_public_path__ + "50e094c5b376ff209d0161d74c73eff1.svg";